import { CheckCircleIcon } from '@heroicons/react/24/solid';
import type { DmDoctorOption, DmPracticeOption } from '../../../../../services/practiceDm';
import { dmPracticePlace } from './dmPracticeText.ts';

interface DmOptionRowProps {
    title: string;
    detail: string;
    id: number;
    selected: boolean;
    onSelect?: () => void;
}

function DmOptionRow({ title, detail, id, selected, onSelect }: DmOptionRowProps) {
    return (
        <button
            type="button"
            onClick={onSelect}
            disabled={!onSelect}
            aria-pressed={selected}
            className={`w-full flex items-center gap-3 rounded-lg border px-3 py-2 text-left transition-colors disabled:cursor-default ${
                selected
                    ? 'border-gray-800 bg-gray-50'
                    : 'border-gray-200 hover:bg-gray-50 hover:border-gray-300'
            }`}
        >
            <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-gray-800">{title}</span>
                <span className="block truncate text-[12px] text-gray-500">{detail}</span>
            </span>
            <span className="font-mono text-[12px] text-gray-500 shrink-0">#{id}</span>
            {selected && <CheckCircleIcon className="h-4 w-4 text-gray-800 shrink-0" />}
        </button>
    );
}

interface DmPracticeOptionRowProps {
    practice: DmPracticeOption;
    selected: boolean;
    onSelect?: () => void;
}

export function DmPracticeOptionRow({ practice, selected, onSelect }: DmPracticeOptionRowProps) {
    return (
        <DmOptionRow
            title={practice.name}
            detail={dmPracticePlace(practice)}
            id={practice.practiceId}
            selected={selected}
            onSelect={onSelect}
        />
    );
}

interface DmDoctorOptionRowProps {
    doctor: DmDoctorOption;
    selected: boolean;
    onSelect?: () => void;
}

export function DmDoctorOptionRow({ doctor, selected, onSelect }: DmDoctorOptionRowProps) {
    const count = doctor.practices.length;
    return (
        <DmOptionRow
            title={doctor.fullName}
            detail={`${doctor.email} · ${count} practice${count === 1 ? '' : 's'}`}
            id={doctor.doctorId}
            selected={selected}
            onSelect={onSelect}
        />
    );
}
